import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';
import React, { CSSProperties } from 'react';
import Highlighter from 'react-highlight-words';

import Storefront from '@mui/icons-material/Storefront';

import { CUSTOM } from '../../../constants/campaigns';
import { MARKETPLACE_CAMPAIGN_LABEL, PICK_YOUR_GIFT_LABEL } from '../../../constants/reports';
import variables from '../../../contexts/ThemeProvider/variables';
import { isMarketplaceCampaignId } from '../../../utils/marketplaceSend';

interface IProps {
  preCreatedEngagementId?: string;
  campaignName?: string;
  searchQuery?: string;
  isPYGChipShown?: boolean;
  highlightStyle?: CSSProperties;
  textSx?: SxProps<Theme>;
}

const ReportCampaignName = ({
  preCreatedEngagementId,
  campaignName,
  searchQuery = '',
  isPYGChipShown,
  highlightStyle,
  textSx,
}: IProps) => {
  if (isMarketplaceCampaignId(preCreatedEngagementId)) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}>
        <Storefront sx={{ fontSize: 16, color: variables.marketplaceAccent }} data-testid="marketplace-campaign-icon" />
        <Typography component="span">{MARKETPLACE_CAMPAIGN_LABEL}</Typography>
      </Box>
    );
  }

  if (isPYGChipShown) {
    return <Chip label={PICK_YOUR_GIFT_LABEL} variant="outlined" sx={{ height: 24 }} />;
  }

  const name = preCreatedEngagementId === CUSTOM ? CUSTOM : campaignName;

  return (
    <Typography sx={textSx} title={name}>
      <Highlighter
        highlightStyle={highlightStyle}
        searchWords={[searchQuery]}
        autoEscape
        textToHighlight={name || ''}
      />
    </Typography>
  );
};

export default ReportCampaignName;
